var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShortlistInactive = function SvgShortlistInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M250 86.62A163.33 163.33 0 1 0 413.32 250 163.33 163.33 0 0 0 250 86.62m77.7 184.51h-56.57v56.57a21.15 21.15 0 0 1-42.28 0v-56.5h-56.57a21.14 21.14 0 0 1 0-42.27h56.57v-56.56a21.15 21.15 0 1 1 42.28-1.2v57.76h56.57a21.14 21.14 0 0 1 0 42.27z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M250 500C111.93 500 0 388.07 0 250S111.93 0 250 0s250 111.93 250 250c-.16 138-112 249.84-250 250m0-474.78C125.86 25.22 25.22 125.86 25.22 250S125.86 474.78 250 474.78 474.78 374.14 474.78 250C474.66 125.91 374.09 25.34 250 25.22"
  })));
};
export default SvgShortlistInactive;